<template>
  <div v-if="livingOption && subsection" class="subsection">    
    <main-content
      :background-image="subsection.backgroundImage"
      right-sidebar="true"
    >
      <img v-if="livingOption.logo" :src="$store.state.assetsPath + livingOption.logo" class="subsection__logo">
      <router-link
        v-for="child in children"
        class="touch"
        :key="child._id"
        tag="div"
        :to="getRouterLink(child)"
      >
        <availability-marker 
          :filtered="child.filter"
          :status="child.status"
          :x="child.marker.x"
          :y="child.marker.y"
        ></availability-marker>
      </router-link>
      <action-bar show-property-key="true">{{ actionText }}</action-bar>
    </main-content>
    <right-sidebar
      :logo="$store.state.config.sidebarLogo"
      :minimap="livingOption.sidebarMinimap"
      :heading="livingOption.label"
      :description="livingOption.description"
      :navigation-items="navigationItems"
    >
      <!-- <div slot="top-slot">
        <property-filter/>
      </div> -->
      <template slot="bottom-slot">
        <router-link tag="button" class="right-sidebar__back" :to="`/live/${livingOption._id}`"><fa icon="chevron-left"/>Back</router-link>
        <div class="right-sidebar__search"></div>
        <!-- <button class="right-sidebar__search"><fa icon="search"/>Search</button> -->
      </template>
    </right-sidebar>
  </div>  
</template>
<script>
// A subsection either links to properties or other subsections
import ActionBar from '@/components/ActionBar'
import AvailabilityMarker from '@/components/AvailabilityMarker'
import MainContent from '@/components/MainContent'
import PropertyFilter from '@/components/PropertyFilter'
import RightSidebar from '@/components/RightSidebar'
import { mapGetters } from 'vuex'
export default {
  name: 'subsection',
  components: { ActionBar, AvailabilityMarker, MainContent, PropertyFilter, RightSidebar },

  computed: {
    ...mapGetters({
      livingOption: 'property/activeLivingOption',
      subsection: 'property/activeSubsection'
    }),

    actionText () {
      const propertyType = this.livingOption.propertyTypes[0] // apartment/townhouse, etc
      const grammerArticle = ['a', 'e', 'i', 'o', 'u'].includes(propertyType.charAt(0)) ? 'an' : 'a' // a/an
      return `select ${grammerArticle} ${propertyType}` // select an/a apartment/townhouse
    },

    children () {
      if (this.subsectionChildType === 'property') {
        return this.subsection.properties
      } else {
        return this.subsection.subsections
      }
    },

    navigationItems () {
      return this.livingOption.subsections.map(subsection => {
        return {
          label: subsection.displayName,
          to: `/live/${this.livingOption._id}/subsection/${subsection._id}`
        }
      })
    },    

    subsectionChildType () {
      if (this.subsection.subsections && this.subsection.subsections.length) {
        return 'subsection'
      } else {
        return 'property'
      }
    }
  },

  methods: {
    getRouterLink (child) {
      if (this.subsectionChildType === 'property') {
        if (child.status !== 'For Sale' && child.status !== 'Hold' && child.status !== 'Hold - Pending Signing') {
          return ''
        } else {
          return `/live/${this.livingOption._id}/subsection/${this.subsection._id}/property/${child._id}`
        }
      } else {
        return `/live/${this.livingOption._id}/subsection/${child._id}`
      }
    }
  }
}
</script>
<style lang="scss">
.subsection {
  &__logo {
    position: absolute;
    top: 3rem;
    right: 4rem;
    z-index: 999;
    max-height: 10rem;
  }
}

.status {
  align-items: center;
  display: flex;
  justify-content: flex-end;

  &__left {
    margin: 0 auto 0 0;
  }

  &__circle {
    border-radius: 50%;
    height: 4rem;
    margin: 0 .4em 0 1.5em;
    width: 4rem;

    &--white {
      background: #fff;
    }

    &--grey {
      background: #999;
    }

    &--black {
      background: #000;
    }
  }

  &__name {
    font-size: 1.6rem !important;
    font-weight: 200;
  }
}
</style>